import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import {
  getAuth,
  GoogleAuthProvider,
  signOut,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  User,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDjk5UHSRO6ITusTXbKjr_45iRkBpamwSY",
  authDomain: "hozenall.cloud", // 認証往復をアプリと同一オリジンに揃え、サードパーティCookie制約を回避
  databaseURL: "https://plexiform-bot-455507-h3-default-rtdb.firebaseio.com",
  projectId: "plexiform-bot-455507-h3",
  storageBucket: "plexiform-bot-455507-h3.firebasestorage.app",
  messagingSenderId: "534182802639",
  appId: "1:534182802639:web:2cd6d3a79a7a66ab6f73ba"
};

// Firebase 初期化
const app = initializeApp(firebaseConfig);

// Firestore 初期化
const db = getFirestore(app);

// Storage 初期化
const storage = getStorage(app);

// -----------------------------------------------------
// Authentication 認証
// -----------------------------------------------------
const auth = getAuth(app);
const provider = new GoogleAuthProvider();


// --- Workspace ドメイン制限用 ---
const ALLOWED_DOMAIN = "hozenall.co.jp";


// -----------------------------------------------------
// Google Workspaceアカウントのみを許可する設定
// -----------------------------------------------------
provider.setCustomParameters({
  hd: ALLOWED_DOMAIN // Google Workspace ドメイン制限
});


// -----------------------------------------------------
// Googleログイン関数
// -----------------------------------------------------
export const loginWithGoogle = async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
    if (window.location.hostname === "localhost") {
      // 開発環境(localhost)はアプリと authDomain が別オリジンになり、リダイレクト方式だと
      // サードパーティ Cookie 制約でログインが成立しないため、ポップアップ方式を使う
      await signInWithPopup(auth, provider);
    } else {
      // 本番(web.app)はアプリと authDomain が同一オリジンのため、別ウィンドウを出さないリダイレクト方式。
      // リダイレクト戻り後にログイン画面が一瞬見えないよう、処理中フラグを立てる（LoginPage で参照）
      sessionStorage.setItem("auth:redirecting", "1");
      await signInWithRedirect(auth, provider);
    }
  } catch (error) {
    console.error("Googleログイン失敗:", error);
    throw error;
  }
};


// -----------------------------------------------------
// リダイレクト後に承認結果を取得
// -----------------------------------------------------
export const handleRedirectResult = async (): Promise<User | null> => {
  try {
    const result = await getRedirectResult(auth);
    if (!result) return null;

    const user = result.user;

    if (!user.email?.endsWith(`@${ALLOWED_DOMAIN}`)) {
      await signOut(auth);
      throw new Error("許可されたドメインのアカウントではありません");
    }

    return user;
  } catch (error) {
    console.error("Redirect結果取得失敗:", error);
    throw error;
  }
};

// ログアウト関数
export const logout = async () => {
  await signOut(auth);
};

export { db, auth, storage };
